import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Modal, Input, DatePicker, Space, Image, ConfigProvider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { exportMayaCredits, formMayaCredits } from "../../utils/api/formsApi";
import CustomToast from "../../components/CustomToast";
import 'antd/dist/reset.css';
import dayjs from 'dayjs';

const baseUrl = process.env.REACT_APP_LINK
function AwardingMayaCredits() {
  const [details, setMessage] = useState({ message: "", type: "" });
  const [showToast, setShowToast] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  
  const [searchData, setSearchData] = useState({
    agent: "",
    dateTo: dayjs(),
    dateFrom: dayjs(),
  });
  
  const [modalVisible, setModalVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [imageTitle, setImageTitle] = useState("");
  const [show, setShow] = useState(false);
  const imageRef = useRef();
  const [fileName, setFileName] = useState("");
  const [image, setImage] = useState("");
  // // Base URL for API
  // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  // const renderImageCell = (text, title) => {
  //   return text ? (
  //     <Button 
  //       type="link" 
  //       onClick={() => {
  //         const cleanPath = text.replace(/^\/+/, '');
  //         const fullUrl = `${API_BASE_URL.replace(/\/+$/, '')}/${cleanPath}`;
  //         setImageUrl(fullUrl);
  //         setImageTitle(title);
  //         setModalVisible(true);
  //       }}
  //     >
  //       View
  //     </Button>
  //   ) : '-';
  // };

  const columns = [
    {
      title: <span className="text-white px-2 py-1 block">ID</span>,
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'center',
    },
    {
      title: <span className="text-white py-1 block">MERCHANT</span>,
      dataIndex: 'merchant',
      key: 'merchant',
      width: 200,
      align: 'center',
    },
    {
      title: <span className="text-white py-1 block">MAYA CREDITS</span>,
      dataIndex: 'received_maya_credits',
      key: 'maya_credits',
      width: 120,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">CHANGE INCENTIVE</span>,
      dataIndex: 'change_incentive',
      key: 'change_incentive',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">VERIFIED PHOTO</span>,
      dataIndex: 'verified_maya_account_photo',
      key: 'verified_photo',
      width: 150,
      align: 'center',
      render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Verified Maya Account Photo')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Verified Maya Account Photo'),
    },
    {
      title: <span className="text-white py-1 block">ACCOUNT NAME</span>,
      dataIndex: 'maya_account_name',
      key: 'account_name',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">ACCOUNT NUMBER</span>,
      dataIndex: 'maya_account_number',
      key: 'account_number',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">CREDIT PHOTO</span>,
      dataIndex: 'received_maya_credit_photo',
      key: 'credit_photo',
      width: 150,
      align: 'center',
      render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Received Maya Credit Photo')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Received Maya Credit Photo'),
    },
    {
      title: <span className="text-white py-1 block">NAME PHOTO</span>,
      dataIndex: 'maya_account_name_photo',
      key: 'name_photo',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">NUMBER PHOTO</span>,
      dataIndex: 'maya_account_number_photo',
      key: 'number_photo',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
      // render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Account Number Photo')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Account Number Photo'),
    },
    {
      title: <span className="text-white py-1 block">AMOUNT TRANSFERRED</span>,
      dataIndex: 'amount_transferred',
      key: 'amount_transferred',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
      // render: (text) => renderImageCell(text, 'Amount Transferred'),
    },
    {
      title: <span className="text-white py-1 block">REFERENCE NO</span>,
      dataIndex: 'reference_no',
      key: 'reference_no',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
      // render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Reference No')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Reference No'),
    },
    {
      title: <span className="text-white py-1 block">POSITION PHOTO</span>,
      dataIndex: 'maya_account_position_photo',
      key: 'position_photo',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
      // render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Account Position Photo')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Account Position Photo'),
    },
    {
      title: <span className="text-white py-1 block">UPLOAD COMPANY ID</span>,
      dataIndex: 'upload_company_id',
      key: 'upload_company_id',
      width: 150,
      align: 'center',
      render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Upload Company ID')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Upload Company ID'),
    },
    {
      title: <span className="text-white py-1 block">CERTIFICATE</span>,
      dataIndex: 'credit_certificate',
      key: 'certificate',
      width: 150,
      align: 'center',
      render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Credit Certificate')}>View Photo</a> : '',
      // render: (text) => renderImageCell(text, 'Credit Certificate'),
    },
    {
      title: <span className="text-white py-1 block">SATISFIED</span>,
      dataIndex: 'is_credit_satisfied',
      key: 'satisfied',
      width: 100,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">FEEDBACK</span>,
      dataIndex: 'maya_credit_feedback',
      key: 'feedback',
      width: 200,
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: <span className="text-white py-1 block">OPTION PRIZE</span>,
      dataIndex: 'credit_option_prize',
      key: 'option_prize',
      width: 150,
      align: 'center',
      render: (text) => text || '-',
    },
  ];

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const handleClose = () => setShow(false);
  const handleShow = (image, file) => {
    setFileName(file);
    setImage(image);
    setShow(true);
    imageRef.current = `${baseUrl}${image}`;
  };

  const handleSearch = async (page = 1, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await formMayaCredits(
        {
          ...searchData,
          dateFrom: searchData.dateFrom.format('YYYY-MM-DD'),
          dateTo: searchData.dateTo.format('YYYY-MM-DD')
        }, 
        page  // ✅ integer na direkta
      );

      if (response?.data?.data) {
        const formattedData = response.data.data.map(item => ({
          ...item,
          key: item.id,
        }));
        
        setData(formattedData);
        setPagination(prev => ({
          ...prev,
          current: page,      // ✅ i-update ang current page
          pageSize: pageSize,
          total: response.data.total_forms || 0,
        }));
      }
    } catch (error) {
      const responseMessage = error.response?.data?.messages?.error || 'Something went wrong.';
      setMessage({ message: responseMessage, type: "danger" });
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      await exportMayaCredits({
        ...searchData,
        dateFrom: searchData.dateFrom.format('YYYY-MM-DD'),
        dateTo: searchData.dateTo.format('YYYY-MM-DD')
      });
      
      setMessage({
        message: 'Export started successfully',
        type: 'success',
      });
      setShowToast(true);
    } catch (error) {
      setMessage({
        message: 'Failed to start export',
        type: 'danger',
      });
      setShowToast(true);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    handleSearch(pagination);
  };

  useEffect(() => {
    handleSearch(1, 10);
    // handleSearch(pagination);
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#FB9C0C',
          borderRadius: 6,
        },
      }}
    >
    <div className="p-2">
      <div className="text-center">
        <div className="col-12">
          <h1 className="title">AWARDING MAYA CREDITS</h1>
        </div>
      </div>
      
      <div className="d-flex flex-wrap gap-3 mb-4 align-items-end">
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Date From</label>
          <DatePicker
            style={{ width: '100%' }}
            value={searchData.dateFrom}
            onChange={(date) => setSearchData({ ...searchData, dateFrom: date })}
            format="YYYY-MM-DD"
            allowClear={false}
          />
        </div>
        
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Date To</label>
          <DatePicker
            style={{ width: '100%' }}
            value={searchData.dateTo}
            onChange={(date) => setSearchData({ ...searchData, dateTo: date })}
            format="YYYY-MM-DD"
            allowClear={false}
          />
        </div>
        
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Agent</label>
          <Input
            placeholder="Search Agent"
            value={searchData.agent}
            onChange={(e) => setSearchData({ ...searchData, agent: e.target.value })}
          />
        </div>
        
        <div className="d-flex align-items-end">
          <Space>
            <Button type="primary" onClick={() => handleSearch(1, pagination.pageSize)}>
              Search
            </Button>
            <Button type="primary" onClick={handleExport} disabled={!data || data.length === 0}>
              Export
            </Button>
          </Space>
        </div>
      </div>
      
      <div className="row">
        <div className="col-12">
          <div style={{ overflowX: 'auto', maxHeight: '70vh', overflowY: 'auto' }}>
            <Table
              // className="no-hover"
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={{
                ...pagination,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                showTotal: (total) => `Total ${total} items`,
                onChange: (page, pageSize) => handleSearch(page, pageSize),
              }}
              scroll={{ x: 'max-content' }}
              bordered
              size="small"
              loading={loading}
            />
          </div>
        </div>
      </div>
      
      <CustomToast
        type={details.type}
        message={details.message}
        title="Awarding Maya Credits"
        show={showToast}
        setShow={setShowToast}
      />
      <Modal 
        title={fileName} 
        open={show} 
        onCancel={handleClose}
        footer={null}
        centered
      >
        <div className="text-center">
          <Image
            src={imageRef.current}
            // fallbackSrc="../../logo.png"
            alt="Incentive Verification Image"
            style={{ 
              maxWidth: "100%", 
              maxHeight: width > 768 ? "70vh" : "50vh",
              objectFit: 'contain'
            }}
            className="img-fluid mx-auto"
          />
        </div>
      </Modal>
      
      <Modal
        title={imageTitle}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        centered
        width={800}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          minHeight: '400px',
          backgroundColor: '#f0f2f5',
          padding: '20px'
        }}>
          {imageUrl ? (
            <div style={{ maxWidth: '100%', maxHeight: '70vh', overflow: 'auto' }}>
              <img 
                src={imageUrl} 
                alt={imageTitle}
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '70vh',
                  display: 'block',
                  margin: '0 auto'
                }}
                onError={(e) => {
                  console.error('Error loading image:', imageUrl);
                  e.target.onerror = null;
                }}
              />
              <div style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
                {imageUrl}
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{ fontSize: '18px', marginBottom: '10px', color: '#666' }}>
                No image available
              </div>
              <div style={{ fontSize: '14px', color: '#999' }}>
                The requested image could not be loaded.
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
    </ConfigProvider>
  );
}

export default AwardingMayaCredits;
